import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { FundingSource } from '../entities/funding-source';

@Injectable()
export class FundingSourceService extends BaseCrudService<FundingSource> {

  public uri = '/api/fundingSource/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance FundingSourceService');
  }

  buildSentence(entity?: FundingSource, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';
      query = query.concat(
        entity.code ?
          `code${QueryOperator.Contain}${entity.code}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.name ?
          `name${QueryOperator.Contain}${entity.name}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.accountingImpact ?
          `accountingImpact${QueryOperator.Contain}${entity.accountingImpact}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.origin ?
          `origin${QueryOperator.Contain}${entity.origin}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      if (entity.fiscalYear && entity.fiscalYear.id) {
        query = query.concat(
          `fiscalYear.id${QueryOperator.Equal}${entity.fiscalYear.id}${QueryOperator.Split}`
        );
      }
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/funding-source.service.ts